import { createContext } from 'react';
import { FlatList, ScrollView } from 'react-native';

export type ScrollContext = {
    isInScroll: boolean;
    onScroll: () => void;
    scrollRef: React.RefObject<ScrollView | FlatList | null> | null;
};

export const ScrollContext = createContext<ScrollContext>({
    isInScroll: false,
    onScroll: () => {},
    scrollRef: null,
});
